<template>
<body>
  <div v-bind:class="{ burgerMenuContainer: true, active: showNav }">
    <div @click="mixNav()" class="burgerHeader">
      <a href="#" class="closeMenu"><i class="far fa-times"></i></a>
    </div>
    <div class="burgerBody">
      <nav>
        <ul class="topMenu">
          <li class="">
            <router-link to="/index" target="_self">
              Home
            </router-link>
          </li>
          <li class="active">
            <router-link to="/shop" target="_self">
              Shop
            </router-link>
          </li>
          <li class="">
            <router-link to="/user/account" target="_self">
              Account
            </router-link>
          </li>
          <li class="">
            <router-link to="/how-it-works" target="_self">
              How It Works
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
    <div class="burgerBot">
      <p>supremeaccess | Legal | Disclousure</p>
    </div>
  </div>
  <div class="flexLayoutShop">
    <div class="leftSidebar">
      <div class="logoContainer">
        <a href="#"><img src="../../assets/images/logo-white.svg" alt="" /></a>
      </div>
      <section class="sidebarBot">
        <div class="sideBotBod">
          <div class="sideBotFlexMenu">
            <li>
              <router-link to="/index">Home</router-link>
            </li>
            <li class="active">
              <router-link to="/shop">Shop</router-link>
            </li>
            <li>
              <router-link to="/user/account">Account</router-link>
            </li>
          </div>
          <div class="sidePageTitle">
            <h1>Shop</h1>
          </div>
        </div>
      </section>
    </div>
    <div class="flexLayoutBody">
      <span class="pageTitleOnMobile">Shop</span>
      <div class="cartSidebar">
        <a href="#" class="closeSidebar"><i class="far fa-times"></i></a>
        <h2>Cart</h2>
        <h2>Select Profile</h2>
        <h2>Order Review</h2>
        <h2>Order Review</h2>
        <div class="itemsInCartGrid">
          <div class="indivItemInCart">
            <div class="itemImg">
              <img src="../../assets/images/lvs.png" alt="" />
            </div>
            <div class="itemInfo">
              <h4>Supreme Backpack</h4>
              <p>Size L</p>
              <a href="#"><i class="far fa-trash"></i></a>
            </div>
          </div>
          <div class="differentProfilesContainer">
            <div class="individProfile mainProfile">
              <h6>John Doe (Main Account)</h6>
              <div class="individInfoP">
                <p>123 Fake Street</p>
                <p>New York, NY 00000</p>
              </div>
            </div>
            <hr />
            <div class="individProfile">
              <h6>John Doe (Main Account)</h6>
              <div class="individInfoP">
                <p>123 Fake Street</p>
                <p>New York, NY 00000</p>
              </div>
            </div>
          </div>
          <div class="orderReviewContainer">
            <div class="individualInput">
              <h4>Coupon</h4>
              <input type="text" name="" id="" value="freesupreme" />
              <span class="percentOff">
                -$150
              </span>
            </div>
            <div class="individualInput">
              <h4>Items (3)</h4>
              <div class="gridListOfInput">
                <div class="individGridList">
                  <h5>Supreme Backpack</h5>
                  <h5>Size L</h5>
                  <h6>$100</h6>
                </div>
                <div class="individGridList">
                  <h5>Supreme Backpack</h5>
                  <h5>Size L</h5>
                  <h6>$100</h6>
                </div>
              </div>
            </div>
          </div>
          <div class="fixedBottomSidebar">
            <div class="totalsContainer">
              <h5>Total:</h5>
              <h5>$150</h5>
            </div>
            <a href="#">Checkout</a>
          </div>
        </div>
      </div>
      <div class="mobileNavTop">
        <a @click="mixNav()" href="#" class="iconBarsMobile"><i class="fas fa-bars"></i></a>
        <div class="logoContainerMobile">
          <a href="#"><img src="../../assets/images/logo-white.svg" alt="" /></a>
        </div>
        <a href="#" class="iconCartMobile openSidebar"><img src="../../assets/images/icon-cart.svg" alt="" /></a>
      </div>
      <div class="flexLayoutTop">
        <div class="flexLayoutShopFilter">
          <nav class="flexLayoutShopFilterActual">
            <li :class="{active: selectedTag == 'all'}"><a @click="selectedTag = 'all'" href="#">All</a></li>
            <li :class="{active: selectedTag == 'new'}"><a @click="selectedTag = 'new'" href="#">New</a></li>
            <li :class="{active: selectedTag == 'clothes'}"><a @click="selectedTag = 'clothes'" href="#">Clothes</a></li>
            <li :class="{active: selectedTag == 'accessories'}"><a @click="selectedTag = 'accessories'" href="#">Accessories</a></li>
            <li :class="{active: selectedTag == 'other'}"><a @click="selectedTag = 'other'" href="#">Other</a></li>
          </nav>
        </div>
        <div class="flexLayoutTopRight">
          <a href="#" class="openSidebar"><img src="../../assets/images/icon-cart.svg" alt="" /></a>
        </div>
      </div>
      <div class="flexLayoutActualBody">
        <div class="fluidGrid">
          <a v-bind:key="index" v-for="(product,index) in products.filter(shouldShow)" class="fluidGridItem">
            <div @click="showProductModal(product)" class="itemGridTop">
              <!-- <h5>${{product.price}}</h5> -->
              <img :src="product.productImage" :alt="product.productTitle" />
              <!-- <img src="../../assets/images/lvs.png" alt="" /> -->
            </div>
            <div class="itemGridBot">
              <h4>{{product.productTitle}}</h4>
              <!-- <h6>${{product.price}}</h6> -->
            </div>
          </a>
          <!-- injected product modal -->

          <div @click.self="hideModal" v-bind:class="{ modalContainer: true, active: selectedProductModal != null }">
            <div class="actualModal">
              <a href="#" class="closeModal" @click="hideModal"><i class="fal fa-times"></i></a>
              <div class="modalBodyOfItem" style="height: auto !important;">
                <div v-if="selectedProductModal != null" class="itemBodyLeftModal">
                  <h4 class="productH4">{{selectedProductModal.productTitle}}</h4>
                  <h5 v-if="!promoPrice" style="margin-bottom: 20px;">${{selectedProductModal.price}}</h5>
                  <h5 v-if="promoPrice" style="margin-bottom: 20px;"><span style="text-decoration: line-through;">${{selectedProductModal.price}}</span> ${{promoPrice}}</h5>
                  <div v-if="selectedProductModal.sizeType != 'OS'" class="sizeGuideContainer">
                    <a @click="selectedSize = 'S'" v-bind:class="{ active: selectedSize == 'S' }" href="#">S</a> <!-- to make it selected, add class .active -->
                    <a @click="selectedSize = 'M'" v-bind:class="{ active: selectedSize == 'M' }" href="#">M</a> <!-- add vue code to keep track of what is selected and what is not -->
                    <a @click="selectedSize = 'L'" v-bind:class="{ active: selectedSize == 'L' }" href="#">L</a>
                    <a @click="selectedSize = 'XL'" v-bind:class="{ active: selectedSize == 'XL' }" href="#">XL</a>
                  </div>

                  <div class="modalSelects">
                    <div style="margin-top: 10px;" role="group" class="modalStyleSelect">
                      <label>Style</label>
                      <select v-model="selectedStyle" class="select-field-3 w-select" required="" autocomplete="off">
                        <!-- <option :value="null">Select Style</option> -->
                        <option :selected="selectedStyle == style || selectedStyle == style.value" v-for="(style,index) in selectedProductStyles" :value="style.value || style" v-bind:key="index">{{style.text || style}}</option>

                      </select>
                    </div>

                    <div role="group" class="modalStyleSelect">
                      <label>Profile</label>
                      <select v-model="selectedProfile" class="select-field-3 w-select" required="" autocomplete="off">
                        <!-- <option :value="null" selected="">Select Size</option> -->
                        <!-- <option :value="null">Select Profile</option> -->
                        <option v-for="(style,index) in profiles" :value="style.profileId|| style" v-bind:key="index">{{style.profileName|| `Main Profile`}}</option>

                      </select>
                    </div>
                  </div>
                  <!-- <div class="itemDesc">
                    <p>
                      Mauris eros mauris, aliquam ut elementum ut, interdum eu arcu.
                      Praesent sodales lacus vitae orci pellentesque, non iaculis eros
                      vehicula. Nullam auctor et arcu quis aliquet.
                    </p>
                  </div> -->
                  <div class="quickCheckout">
                    <a @click="confirmSecure" href="#">{{buttonText || 'Secure Checkout'}}</a>
                    <!-- <small>
                        Mauris eros mauris, aliquam ut elementum ut, interdum eu arcu.
                        Praesent sodales lacus vitae.
                    </small> -->
                  </div>
                </div>
                <div v-if="selectedProductModal != null" class="itemBodyRightImage">
                  <div class="itemImage">
                    <img :src="selectedProductModal.productImage" alt="" />
                    <!-- <img src="../../assets/images/lvs.png" alt="" /> -->
                  </div>
                </div>
              </div>
            </div>
            <!-- confirm modal -->
            <div v-if="confirmingSecure" class="modalContainer active loginModal formsModal">
              <div class="actualModal">
                <a @click="confirmingSecure = false" href="#" class="closeModal"><i class="fal fa-times"></i></a>
                <div class="modalBodyOfItem">
                  <div class="itemBodyLeftModal">
                    <h4>Confirm Slot.</h4>
                    <p class="formPara">
		    This will secure the {{selectedProductModal.productTitle}} slot for you. To optimize success, if your size or style isn't available, we will select the next available size / style.
		    <!--This will secure the {{selectedProductModal.productTitle}} slot for you. A ${{selectedProductModal.price}} hold will be placed on your card. If your slot fails, the hold is instantly dropped.-->
                      <!-- Account created. Continue and explore Supreme Access. -->
                    </p>
                    <div class="quickCheckout">
                      <a @click="secureDatShit(selectedProductModal)" href="#">Secure Now</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </div>

        </div>


        <!-- ./ injected product modal -->
        <!--<a class="fluidGridItem">
              <div class="itemGridTop">
                <h5>$100</h5>
                <img src="../../assets/images/lvs.png" alt="" />
              </div>
              <div class="itemGridBot">
                <h4>Supreme Backpack</h4>
                <h6>$100</h6>
              </div>
            </a> -->
      </div>
    </div>
  </div>
  <div class="crossModalContainer"></div>
</body>
</template>
<script>
import { productService } from '@/services/product'
import {
  userService
} from '@/services/user'
import { checkoutService } from '@/services/checkout'
export default {
  computed: {
    promoPrice(price) {
      let {promoCodeData} = this
      let {selectedProductModal} = this
      if(promoCodeData && selectedProductModal && promoCodeData.percent) {
        let {percent} = promoCodeData
        if(!percent) return null
        let takeOff = (percent / 100) * selectedProductModal.price
        let promoPrice = selectedProductModal.price - takeOff
        return promoPrice
      }
    },
    promoCodeData() {
      return this.$store.state.promo.codeData

    },
    promoCode() {
      return this.$store.state.promo.promoCode
    },
    profiles() {
      return this.$store.state.profiles.profiles
    },
    userInfo() {
      // return this.$store.state.orders.aco
      let { user } = this.$store.state.auth
      // console.log(user,this.$store.state.auth)
      if (!user) return null
      return user.info
    },
    realSize() {
      let { selectedSize } = this
      let { selectedProductModal } = this
      if (!selectedSize && selectedProductModal.sizeType == 'OS') return 'OS'
      return selectedSize
    },
    selectedProductStyles() {
      let { selectedProductModal } = this
      if (selectedProductModal && selectedProductModal.styles) {
        let split = selectedProductModal.styles.split(',')
        if (split && split.length > 0) {
          return split
        } else {
          return [{ text: 'One Style', value: 'OS' }]
        }

      } else {
        return [{ text: 'One Style', value: 'OS' }]
      }
    },
  },
  watch: {
    selectedProductModal(n, o) {
      // console.log()
      if (n && n.productId) {
        if (this.selectedProductStyles) {

          this.selectedStyle = this.selectedProductStyles[0].value || this.selectedProductStyles[0]
        }
      }
      if (this.profiles[0] && this.profiles[0].profileId) {
        this.selectedProfile = this.profiles[0].profileId
      }
    }
  },
  data() {
    return {
      confirmingSecure: false,
      strictNeedProfileAndCard: false,
      selectedProductModal: null,
      products: [],
      showNav: false,
      selectedTag: 'all',
      selectedSize: null,
      selectedStyle: null,
      selectedProfile: null,
      buttonText: 'Secure Now'
    }
  },
  async created() {
    console.log("/#/shop created");
    this.$store.dispatch('auth/fetchUser')
    await this.getProducts()
    userService.userInfo()
      .then(n => {
        // console.log(n, 33)
        if (!this.strictNeedProfileAndCard) return
        if (n.isAdmin) return
        if (!n) return this.$router.push('/step1')
        if (!n.customer_id) return this.$router.push('/step1')
        if (!n.profiles || n.profiles.length < 1) return this.$router.push('/step1')
      })
      .catch(e => {
        console.log(e)
      })
    this.$store.dispatch('profiles/getProfiles')
    if(localStorage.getItem('promoCode')) this.$store.dispatch('promo/getCode')
  },
  methods: {
    checkForUserInfo() {},
    gotoHome() {
      if (this.$route.path != '/' && this.$route.path != '/shop') this.$router.push('/')
    },
    secureDatShit(product) {
      this.confirmingSecure = false
      this.secureNow(product)

    },
    confirmSecure() {
      let { realSize, selectedStyle, selectedProfile } = this
      // console.log(realSize,selectedStyle,selectedProfile)
      if (!realSize || !selectedStyle || !selectedProfile) return console.error('incomplete form')
      this.confirmingSecure = true
    },
    sendGoogleEvent(order) {
      /*gtag('event', 'purchase', {
  "transaction_id": "24.031608523954162",
  "affiliation": "Google online store",
  "value": 23.07,
  "currency": "USD",
  "tax": 1.24,
  "shipping": 0,
  "items": [
    {
      "id": "P12345",
      "name": "Android Warhol T-Shirt",
      "list_name": "Search Results",
      "brand": "Google",
      "category": "Apparel/T-Shirts",
      "variant": "Black",
      "list_position": 1,
      "quantity": 2,
      "price": '2.0'
    },
    {
      "id": "P67890",
      "name": "Flame challenge TShirt",
      "list_name": "Search Results",
      "brand": "MyBrand",
      "category": "Apparel/T-Shirts",
      "variant": "Red",
      "list_position": 2,
      "quantity": 1,
      "price": '3.0'
    }
  ]
});*/
      gtag('event', 'purchase', {
        "transaction_id": order.orderId,
        // "affiliation": "Google online store",
        "value": order.price,
        "currency": "USD",
        // "tax": 1.24,
        // "shipping": 0,
        "items": [
          {
            "id": order.productId,
            "name": order.productTitle,
            // "list_name": "Search Results",
            // "brand": "Google",
            // "category": "Apparel/T-Shirts",
            "variant": order.style,
            // "list_position": 1,
            "quantity":1,
            "price":  order.price,
          },
        ]
      });
    },
    secureNow(product) {
      console.log(`secureNow called`)
      let { realSize, selectedStyle } = this
      console.log(realSize, selectedStyle)
      if (!realSize && !selectedStyle) return console.log(`no size / selectedStyle / profile selected`)
      this.buttonText = 'Securing...'
      let profileId = this.selectedProfile
      console.log(`checking out slot for product ${product.productTitle} with profile ${profileId} and size ${this.realSize} and style ${selectedStyle}`)
      let checkoutPayload = { productId: product.productId, style: selectedStyle, size: realSize, profileId }
      if(this.promoCode) checkoutPayload.promoCode = this.promoCode
      checkoutService.withProfile(checkoutPayload)
        .then(resp => {
          let { order } = resp
          let orderId
          if (order) orderId = order.orderId
          console.log(`order ${orderId} placed!`)
          this.buttonText = 'Secured.'
          this.sendGoogleEvent(order)
          setTimeout(() => {
            this.buttonText = 'Redirecting...'
            setTimeout(() => {
              this.$router.push('/user/orders')
            }, 2000)
          }, 2000)
        })
        .catch(e => {
          console.error(e)
          if(e.response && e.response.data) {
            console.error(e.response.data.error || e.response.data)
            if(e.response.data.error == 'duplicate') {
              this.buttonText = 'Select New Profile'
            }
          } else {
            this.buttonText = 'Error. Refresh.'
          }
          setTimeout(() => {
            this.buttonText = 'Secure Now'
          }, 3000)
        })

      /* we are live faggot
      setTimeout(() => {
        this.buttonText = 'Secured!'
        setTimeout(() => {
          this.buttonText = 'Redirecting...'
        }, 2500)
      }, 2000) */

    },
    gotoProductMobile(product) {
      console.log(`redirectig to product page on mobile`)
      this.$router.push({
        path: '/product',
        query: {
          productId: product.productId
        }
      })
    },
    shouldShow(product) {
      // console.log(product)
      let {
        tags
      } = product
      let {
        selectedTag
      } = this
      if (this.selectedTag == 'all' || selectedTag == 'new') return true
      if (!tags) return console.log(`no tags on product ${product.productTitle}`)
      if (tags.indexOf(selectedTag) != -1) return true
      // console.log(tags, selectedTag)
      // return false


    },
    mixNav() {
      this.showNav = !this.showNav
    },
    async getProducts() {
      try {
        let resp = await productService.getAvailProducts()
        this.products = resp
      } catch (e) {
        console.error(e)
      }
    },
    showProductModal(product) {
      if (!this.userInfo.billingAddress) return this.$router.push('/signup2')
      if (!this.userInfo.customer_id) return this.$router.push('/signup3')
      this.selectedProductModal = product;
    },
    hideModal() {
      this.selectedProductModal = null;
    }
  }
}
</script>
